import type { Species } from '../api/contract';

export const SPECIES: Record<Species, { name: string; latin: string }> = {
  cepe: { name: 'Cèpe', latin: 'Boletus edulis' },
  girolle: { name: 'Girolle', latin: 'Cantharellus cibarius' },
};
